import styled from "styled-components";
import { getHexOpacity } from "../../../../../utils/pipes";

export const FolderContent = styled.div`
  width: 100%;
  height: 100%;
  .empty-content {
    width: 100%;
    height: 100%;
    border-radius: 20px;  
    background: #FFFFFF78;
    border: 1px solid #FFFFFF;
  }
` 